import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { site } from "../config/site";

const texts = {
  aviso: {
    title: "Aviso legal",
    body: `1. Titular del sitio web

En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos del titular:

· Titular: Lidia Montiel — ${site.fullName}
· NIF/DNI: 48968833Q
· Domicilio profesional: Calle Ayala, C.C. La Plaza, planta 1, local 23, 11130 Chiclana de la Frontera (Cádiz)
· Correo electrónico: ${site.email}
· Teléfono: ${site.phoneDisplay}
· Actividad: servicios de psicopedagogía, evaluación psicopedagógica, reeducación pedagógica, técnicas de estudio y orientación académica y familiar.

2. Objeto

Este sitio web tiene por objeto informar sobre los servicios de ${site.fullName} y facilitar un canal de contacto con las familias interesadas. El acceso y uso de la web atribuye la condición de usuario e implica la aceptación de las presentes condiciones.

3. Propiedad intelectual

Los contenidos de este sitio web (textos, logotipo, fotografías y diseño) son titularidad de ${site.name} o se utilizan con autorización, y no pueden reproducirse ni utilizarse sin consentimiento expreso.

4. Responsabilidad

La información publicada tiene carácter meramente informativo y no sustituye en ningún caso una valoración psicopedagógica individualizada. La titular no se responsabiliza del uso que los usuarios puedan hacer de los contenidos de la web.

5. Legislación aplicable

Las presentes condiciones se rigen por la legislación española. Para cualquier controversia serán competentes los juzgados y tribunales de Cádiz, salvo fuero imperativo distinto.`,
  },
  privacidad: {
    title: "Política de privacidad",
    body: `Conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD), se informa sobre el tratamiento de los datos personales recabados a través de este sitio web:

1. Responsable del tratamiento

· Identidad: Lidia Montiel — ${site.fullName}
· NIF/DNI: 48968833Q
· Domicilio: Calle Ayala, C.C. La Plaza, planta 1, local 23, 11130 Chiclana de la Frontera (Cádiz)
· Correo electrónico: ${site.email}

2. Datos que se recaban y finalidad

A través del formulario de contacto se recaban: nombre de la persona adulta, correo electrónico, teléfono (opcional) y el motivo general de la consulta. Estos datos se utilizan única y exclusivamente para responder a la consulta recibida y, en su caso, concertar una primera cita.

El formulario no está destinado a recabar información sensible ni datos detallados sobre menores. Rogamos no incluir en él información clínica o especialmente protegida.

3. Base jurídica

El tratamiento se basa en el consentimiento de la persona usuaria, otorgado al marcar la casilla de aceptación y enviar el formulario (art. 6.1.a RGPD).

4. Destinatarios y encargados

Los datos no se ceden a terceros. El proveedor de alojamiento y envío de correo de esta web actúa como encargado del tratamiento conforme al art. 28 RGPD.

5. Conservación

Los datos se conservarán durante el tiempo necesario para atender la consulta y, una vez finalizada la relación, durante los plazos de prescripción legal aplicables.

6. Derechos

Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a ${site.email}, adjuntando un documento que acredite tu identidad. Si consideras que el tratamiento no se ajusta a la normativa, puedes reclamar ante la Agencia Española de Protección de Datos (www.aepd.es).`,
  },
  cookies: {
    title: "Política de cookies",
    body: `1. ¿Qué son las cookies?

Las cookies son pequeños archivos que los sitios web almacenan en el dispositivo del usuario para recordar información sobre su visita.

2. Cookies utilizadas en este sitio web

· Cookies técnicas (necesarias): imprescindibles para el funcionamiento básico y la seguridad de la web. No requieren consentimiento.

3. Cookies de análisis y herramientas de medición

El banner que aparece en tu primera visita te permite aceptar o rechazar las cookies de análisis, y puedes cambiar tu decisión en cualquier momento desde «Preferencias de cookies», en el pie de página. En este momento la web no utiliza ninguna herramienta de analítica activa.

Está previsto incorporar Google Analytics y Google Search Console para conocer el rendimiento de la web en los buscadores. Estas herramientas solo se activarán tras tu consentimiento expreso y esta política se actualizará entonces con su detalle.

4. Cómo desactivar las cookies

Puedes configurar tu navegador para rechazar o eliminar las cookies desde los apartados de privacidad de Chrome, Firefox, Safari o Edge. Ten en cuenta que bloquear las cookies técnicas puede afectar al funcionamiento de la web.

5. Actualización

Esta política puede actualizarse cuando se incorporen nuevas herramientas. Fecha de la última revisión: octubre de 2026.`,
  },
};

export default function LegalModals({ open, onClose }) {
  const t = open ? texts[open] : null;
  return (
    <Dialog open={!!open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="legal-dialog" className="bg-ivory max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-atento-blue">{t?.title}</DialogTitle>
          <DialogDescription className="sr-only">{t?.title} de {site.fullName}</DialogDescription>
        </DialogHeader>
        <div className="text-sm leading-relaxed text-charcoal/75 whitespace-pre-line max-h-[60vh] overflow-y-auto pr-2">
          {t?.body}
        </div>
      </DialogContent>
    </Dialog>
  );
}
